export default __webpack_public_path__ + "static/ai-marketing-7-7c47811e8417db636ed89441f71cb270.webp";